import React from 'react';
import { Box, Typography, Divider, Paper } from '@mui/material';

interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  icon,
  actions
}) => {
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, 
        mb: 3,
        backgroundColor: 'background.paper',
        borderRadius: 2,
        borderBottom: 1,
        borderColor: 'divider'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {icon && (
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                backgroundColor: 'action.hover',
                borderRadius: '50%',
                p: 1.5,
              }}
            >
              {icon}
            </Box>
          )}
          <Box>
            <Typography 
              variant="h4" 
              component="h1" 
              sx={{ 
                fontWeight: 'bold',
                fontSize: { xs: '1.5rem', sm: '2rem' }
              }}
            >
              {title}
            </Typography>
            {description && (
              <Typography 
                variant="subtitle1" 
                color="text.secondary"
                sx={{ mt: 0.5 }}
              >
                {description}
              </Typography>
            )}
          </Box>
        </Box>
        
        {actions && (
          <Box>
            {actions}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default PageHeader; 